/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetScopeDetails {
    getFixupPrototypeFunction() { return BudgetScopeDetails.fixupPrototype; }

    static newInstance(model: Partial<BudgetScopeDetails>): BudgetScopeDetails {
        let obj = Object.assign(new BudgetScopeDetails(), model);
        BudgetScopeDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetScopeDetails>): BudgetScopeDetails {
        if (!model) return null;
        return BudgetScopeDetails.newInstance(<BudgetScopeDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetScopeDetails) {
        if (!obj) return;

        models.BudgetScopeDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetScopeDetails): boolean {
        Object.setPrototypeOf(obj, BudgetScopeDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filters) {
            models.BudgetAdvancedFilter.fixupPrototype(this.filters);
        }
    }

    cloud: Array<models.CloudServiceName>;

    /**
     * advanced filters details of the specific budget mentioned
     */
    filters: models.BudgetAdvancedFilter;

    tenant: Array<string>;

    cloud_account: Array<string>;

    /**
     * Service account Ids.
     */
    service_account_ids: Array<string>;

    grouping_rule_ids: Array<string>;

    /**
     * dimension id
     */
    dimension_id: string;

    /**
     * name of the budget scope
     */
    name: string;

    /**
     * entity type for the budget scope. This is a unique entity type and can be retrieved.
     */
    entity: string;

    values: Array<string>;

}
